import React from "react";
import { useTheme } from "@mui/material";

const DateDisplay = ({ toDate }: { toDate: string }) => {
    const theme = useTheme();
    const date = new Date(toDate);
    const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase(); // e.g., "NOV"
    const day = date.getDate().toString().padStart(2, "0"); // e.g., "01"

    const isSmallScreen = window.innerWidth <= theme.breakpoints.values.sm;

    return (
        <div
            style={{
                ...containerStyle,
                flexDirection: isSmallScreen ? "row" : "column",
                alignItems: isSmallScreen ? "center" : "initial",
                justifyContent: isSmallScreen ? "center" : "initial",
                gap: isSmallScreen ? "8px" : "0", // Add spacing for small screens
            }}
        >
            <div style={{ ...monthStyle, fontSize: isSmallScreen ? "16px" : "20px" }}>
                {month}
            </div>
            <div style={{ ...dayStyle, fontSize: isSmallScreen ? "32px" : "48px" }}>
                {day}
            </div>
        </div>
    );
};

const containerStyle: React.CSSProperties = {
    display: "flex",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
    width: "100px", // Adjust as needed
    padding: "10px",
    borderRadius: "8px",
};

const monthStyle: React.CSSProperties = {
    fontSize: "20px",
    fontWeight: "bold",
};

const dayStyle: React.CSSProperties = {
    fontSize: "48px",
    color: "#9c3e9c",
    fontWeight: "bold",
};

export default DateDisplay;
